// @ts-nocheck
import Utils from 'src/utils';
import { isEmpty, isNil } from 'ramda';
export default (option, dayjsClass, dayjsFactory) => {
    const originalDuration = dayjsFactory.duration;
    dayjsFactory.duration = (input, unit) => {
        if (isNil(input) || isEmpty(input))
            return originalDuration(0);
        else if (typeof input === 'string') {
            const parsed = Utils.time.splitTimeSpan(input);
            if (parsed) {
                return originalDuration(parsed); // Use parsed object for timespan
            }
        }
        return originalDuration(input, unit);
    };
};
